import {create} from 'zustand';
import {UseCoordinatesStore} from './types';

const useCoordinatesStore = create<UseCoordinatesStore>(set => ({
	coordinates: null,
	setCoordinates: value => set({coordinates: value}),
}));

export {useCoordinatesStore};
